import { MantineThemeOverride, ColorScheme, rem } from '@mantine/core';
import {
  getMantinePrimaryColorsArray,
  getMantineSecondaryColorsArray,
  lightThemeColors,
  darkThemeColors,
} from './themeConfig';
import { commonColorsArrObj, commonColors } from '../themeOld/newColors';

const theme: MantineThemeOverride = {
  colorScheme: 'light',
  focusRing: 'auto',
  cursorType: 'pointer',
  defaultRadius: 'xs',

  colors: {
    // TODO
    // commonColorsArrObj has to be removed
    ...commonColorsArrObj,
    ...getMantinePrimaryColorsArray(),
    ...getMantineSecondaryColorsArray(),
  },
  fontFamily: 'Inter, sans-serif',
  lineHeight: '130%',
  fontSizes: {
    xs: rem(14),
    sm: rem(16),
    md: rem(18),
    lg: rem(20),
    xl: rem(24),
  },
  radius: {
    xs: rem(2),
    sm: rem(4),
    md: rem(8),
    lg: rem(16),
    xl: rem(32),
  },
  spacing: {
    xs: rem(2),
    sm: rem(4),
    md: rem(8),
    lg: rem(16),
    xl: rem(32),
  },
  breakpoints: {
    xs: rem(576),
    sm: rem(768),
    md: rem(992),
    lg: rem(1200),
    xl: rem(1400),
  },
  headings: {
    sizes: {},
  },

  loader: 'dots',
  primaryColor: 'primary',
  primaryShade: 5,
  datesLocale: 'en',
};

const opacities = {
  20: '20%',
  40: '40%',
  60: '60%',
  80: '80%',
};

const shadows = {
  xs: '0px 1px 2px rgba(16, 24, 40, 0.05)',
  sm: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
  md: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
  lg: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
  xl: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
  xxl: '0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
  xxxl: '0px 32px 64px -12px rgba(16, 24, 40, 0.14)',
};

export const getCustomTheme = (colorScheme:ColorScheme):MantineThemeOverride => {
  if (colorScheme === 'dark') {
    return {
      ...theme,
      colorScheme,
      other: {
        colors: {
          ...darkThemeColors,
          // TODO
          // only lightThemeColors has to be kept, other all has to be removed
          transparent: ['#00000000'],
          // primary: '#963A72',
          primaryHover: '#9e3f79',
          primaryText: '#ffffff',
          secondaryText: '#BFBFBF',
          background: '#0C0C0C',
          backgroundLight: '#1f1f1f',
          backgroundInputs: '#FFFFFF1A',
          ...commonColors,
        },
        opacity: opacities,
        shadow: shadows,
        screenWidth: 1440,
        navHeight: 80,
        navHeightMobile: 42,
      },
    };
  }
  return {
    ...theme,
    colorScheme,
    other: {
      colors: {
        ...lightThemeColors,
        // TODO
        // only lightThemeColors has to be kept, other all has to be removed
        transparent: ['#00000000'],
        // primary: '#963A72',
        primaryHover: '#9e3f79',
        primaryText: '#ffffff',
        secondaryText: '#BFBFBF',
        background: '#0C0C0C',
        backgroundLight: '#1f1f1f',
        backgroundInputs: '#FFFFFF1A',
        ...commonColors,
      },
      opacity: opacities,
      shadow: shadows,
      screenWidth: 1440,
      navHeight: 80,
      navHeightMobile: 42,
    },
  };
};
export default theme;
